const processInvoiceData = (
  invoices,
  plantId,
  invoiceDetails,
  totals,
  energyValu,
  mainEnergy
) => {
  const filteredInvoices = invoices.filter(
    (invoice) => invoice.plantId === plantId && invoice.paymentStatus !== 'PAID'
  )

  const getMonthName = (monthNum) => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    return months[parseInt(monthNum) - 1]
  }

  const formatTransactionNumber = (invoiceNumber, index) => {
    const yearMonth = invoiceNumber.slice(-6)
    const year = yearMonth.slice(0, 4)
    const month = yearMonth.slice(4)
    const sequentialNum = String(index + 1).padStart(3, '0')
    return `INV-${year}/${month}-${sequentialNum}`
  }

  const newPayments = filteredInvoices.map((invoice, index) => {
    const monthNum = invoice.invoiceNumber.slice(-2)

    const monthName = getMonthName(monthNum)

    // Check if current invoice matches with invoiceDetails
    const isMatchingInvoice =
      invoiceDetails?.[0]?.invoiceNumber === invoice.invoiceNumber

    const totalAmount =
      invoice.type === 'EMI' ? totals?.totaltarif : totals?.totalAmount

    // Calculate invoice amount based on totals if it's the matching invoice
    const calculatedInvoiceAmount = isMatchingInvoice
      ? totalAmount
      : invoice.invoiceValue

    // Calculate pending amount based on status
    const calculatedPendingAmount =
      invoice.paymentStatus === 'PAID' ? 0 : calculatedInvoiceAmount

      return {
        _id: invoice._id || null,
        id: `payment-${index}`,
        invoiceID: invoice.invoiceNumber || '',
        date: monthName || '',
        transactionNo: invoice.invoiceNumber ? formatTransactionNumber(invoice.invoiceNumber, index) : '',
        type: invoice.type || 'INVOICE',
        status: invoice.paymentStatus || 'UNPAID',
        invoiceAmount: calculatedInvoiceAmount || 0,
        pendingAmount: calculatedPendingAmount || 0
      }
  })

  return newPayments
}

export default processInvoiceData
